// extracted by mini-css-extract-plugin
module.exports = {"root":"third_root__WN8Z_","check":"third_check__Vh8l4"};